import { combineReducers } from "redux";
import { messageDetailReducer } from "./messageDetailReducer";
import { sessionReducer } from "./sessionReducer";
export const rootReducer = combineReducers({
  messageDetail: messageDetailReducer,
  // session: sessionReducer,
});
